import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { X } from "lucide-react";
import ContactForm from "../components/ContactForm";

const Ctx = createContext({ open: false, openModal: () => {}, closeModal: () => {} });

export const useContactModal = () => useContext(Ctx);

export const ContactModalProvider = ({ children }) => {
  const [open, setOpen] = useState(false);

  const openModal = useCallback(() => setOpen(true), []);
  const closeModal = useCallback(() => setOpen(false), []);

  useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setOpen(false); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  return (
    <Ctx.Provider value={{ open, openModal, closeModal }}>
      {children}
      {open && (
        <div
          data-testid="contact-modal"
          className="fixed inset-0 z-[100] flex items-center justify-center px-4 sm:px-6"
          role="dialog"
          aria-modal="true"
        >
          {/* Backdrop */}
          <div
            data-testid="contact-modal-backdrop"
            className="absolute inset-0 bg-ink/70 backdrop-blur-sm"
            onClick={closeModal}
          />
          {/* Card */}
          <div className="relative w-full max-w-2xl bg-alabaster rounded-3xl shadow-2xl overflow-hidden max-h-[92vh] flex flex-col animate-fade-up">
            <div className="flex items-center justify-between px-6 sm:px-8 py-5 border-b border-alabaster-line">
              <div>
                <div className="eyebrow">Contact</div>
                <h3 className="font-display text-2xl sm:text-3xl font-bold text-ink mt-1">
                  Let's <span className="text-terracotta">join forces</span>.
                </h3>
              </div>
              <button
                data-testid="contact-modal-close"
                onClick={closeModal}
                className="w-10 h-10 rounded-full bg-alabaster-surface hover:bg-terracotta hover:text-alabaster text-ink flex items-center justify-center transition-colors"
                aria-label="Close"
              >
                <X size={18} />
              </button>
            </div>
            <div className="overflow-y-auto p-6 sm:p-8">
              <ContactForm compact onSuccess={() => { /* keep open so user sees confirmation */ }} />
            </div>
          </div>
        </div>
      )}
    </Ctx.Provider>
  );
};
